import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

@Component({
  selector: 'dmmp-content-search-result',
  templateUrl: './content-search-result.component.html'
})
export class ContentSearchResultComponent implements OnInit {

  @Input() module
  @Input() identifier
  @Input() defaultClass = 'content-search-result'

  @Input() articlesResult
  @Input() searchResult = []

  @Output() anchorCustom = new EventEmitter()
  @Output() page = new EventEmitter()
  @Input() loaderState = false

  constructor() { }

  ngOnInit(): void {
  }

}
